/**
 * Costanti fiscali centralizzate — fonte di verità unica per tassi, massimali,
 * soglie e codici tributo del regime forfettario.
 *
 * Valori validati dal commercialista. Aggiornare le voci marcate "da confermare"
 * alla pubblicazione dei relativi decreti/circolari.
 *
 * NB: le aliquote INPS (gestione separata / artigiani / commercianti) restano
 * in src/constants/aliquote.js, che è la fonte unica e fornisce getAliquotaINPS().
 */

// Tasso di interesse legale annuo (art. 1284 c.c.) — usato per ravvedimento operoso.
// Aggiornare annualmente con Decreto MEF.
export const TASSI_LEGALI = {
  2023: 0.05,   // 5%
  2024: 0.025,  // 2,5%
  2025: 0.02,   // 2%
  2026: 0.02,   // 2% (provvisorio, da aggiornare a dicembre 2025)
};

// Massimale contributivo INPS Gestione Separata. Sull'eccedenza non si versa il
// contributo ordinario ma il contributo aggiuntivo DPPI all'1% (NON 10%) —
// vedi calcolaDPPI in src/utils/fiscalEngine.js.
export const MASSIMALI_INPS = {
  2024: 119650,
  2025: 120607,
  2026: null,   // da confermare a gennaio 2026
};

// Imposta sostitutiva: aliquota agevolata "startup" per i primi anni di
// attività, poi aliquota standard. L'aliquota di un anno dipende da quanti anni
// di attività erano trascorsi IN QUELL'ANNO — vedi getAliquotaSostitutiva in
// src/utils/fiscalEngine.js.
export const ALIQUOTA_IMPOSTA_AGEVOLATA = 5;
export const ALIQUOTA_IMPOSTA_STANDARD = 15;
export const ANNI_ALIQUOTA_AGEVOLATA = 5;

// Soglia sotto la quale l'acconto si versa in unica soluzione a novembre.
export const SOGLIA_ACCONTO_UNICO = 257.52;

// Ripartizione dell'acconto in due rate (giugno/novembre) quando supera la soglia.
export const SPLIT_ACCONTI = {
  giugno: 0.4,
  novembre: 0.6,
};

// Interesse mensile per la rateazione del saldo/acconti (art. 20 D.Lgs. 241/1997).
export const INTERESSE_RATEAZIONE_MENSILE = 0.0033;  // 0,33%/mese

// Aliquota del contributo aggiuntivo DPPI sull'eccedenza del massimale INPS
// gestione separata. È l'1% (NON il 10%).
export const ALIQUOTA_DPPI = 0.01;

// Codici tributo F24 per il regime forfettario.
export const CODICI_TRIBUTO = {
  erario: {
    acconto1: '1790',           // Imposta sostitutiva - I acconto
    acconto2: '1791',           // Imposta sostitutiva - II acconto
    saldo: '1792',              // Imposta sostitutiva - Saldo
    interessiRateazione: '1668', // Interessi pagamento dilazionato
  },
  inps: {
    unicaSoluzione: 'PXX',       // Contributi gestione separata - unica soluzione
    rateale: 'PXXR',             // Contributi gestione separata - rateale
    contributoAggiuntivo: 'DPPI', // Contributo aggiuntivo 1% su eccedenza massimale
  },
  bollo: '2501',                 // Imposta di bollo su fatture
};
